export default "__VITE_ASSET__D$y8Be_5__"